import React, {Component} from "react";
import "./LogoutPage.css";
import Button from "../components/Button";
import { withApollo } from 'react-apollo';

class LogoutPage extends Component {

  componentDidMount() {
    this.props.client.resetStore();
  }

  render() {
    return (
      <div className="LogoutPage">
        <div className="inner">
          <p>You have been logged out.</p>
          <Button label="login" onClick={this.handleLogin.bind(this)} />
        </div>
      </div>
    )
  }

  handleLogin() {
    this.props.showLogin();
  }

}

export default withApollo(LogoutPage);